import { render, staticRenderFns } from "./GameCompleted.vue?vue&type=template&id=34970e14&scoped=true&"
import script from "./GameCompleted.vue?vue&type=script&lang=ts&"
export * from "./GameCompleted.vue?vue&type=script&lang=ts&"
import style0 from "./GameCompleted.vue?vue&type=style&index=0&id=34970e14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34970e14",
  null
  
)

export default component.exports